import angular from 'angular';
import moment from 'moment';
import gridHeight from '../core/shared-service/grid-utils';

class companiesListCtrl {
  /* @ngInject */
  constructor(
    $uibModal,
    $sessionStorage,
    uiGridExporterConstants,
    $translate,
    PrincipalSvc,
    AuthSvc,
    $state,
    CompanyService,
    SessionSvc,
    logger
  ) {
    this.$uibModal = $uibModal;
    this.$sessionStorage = $sessionStorage;
    this.uiGridExporterConstants = uiGridExporterConstants;
    this.$translate = $translate;
    this.PrincipalSvc = PrincipalSvc;
    this.AuthSvc = AuthSvc;
    this.$state = $state;
    this.CompanyService = CompanyService;
    this.SessionSvc = SessionSvc;
    this.logger = logger;
    this.platformSens = {
        RE:'RE',
        EM:'EM'
    }
  }

  $onInit() {
      this.platformColumnsVisibility = {
          RE: this.isAdminOrConfigurator() && this.principal.detail.authorizedPdpRe,
          EM: this.isAdminOrConfigurator() && this.principal.detail.authorizedPdpEm,
      };
    this.criteria =
      this.keepSearchData && this.$sessionStorage.companySearchCriteria
        ? this.$sessionStorage.companySearchCriteria
        : { principalId: this.principal.detail.id };

    let aHrefTemplate =
      '<a class="grid-cell-link" ui-sref="app.principal.consult.detailscompanies({legalEntityId : row.entity.companyId, previousState:{name:grid.appScope.$ctrl.currentStateName, params:grid.appScope.$ctrl.stateParams}})">';
    var defaultCellTemplate =
      aHrefTemplate +
      '<div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
    var countryCellTemplate =
      aHrefTemplate +
      '<div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{\'country.\'+ COL_FIELD CUSTOM_FILTERS | lowercase | translate }}</div></a>';
    var signOutCellTemplate =
      '<div class="ui-grid-cell-contents text-center" ng-click="grid.appScope.$ctrl.openConfirmCompanySignOut(row.entity)"><span><i class="fa fa-sign-out"></i></span></div>';
      let dateCellTemplate =
          aHrefTemplate +
          "<div class=\"ui-grid-cell-contents ui-grid-cursor-pointer\">{{COL_FIELD ? (COL_FIELD.split('-').reverse().join('/')) : '-'}}</div></a>";

    // Gestion de la grille
    this.gridOptions = {
        columnDefs: [
            {
                name: 'companyId',
                displayName: 'ID Société',
                cellTemplate: defaultCellTemplate,
                cellClass: 'pointer text-center',
            },
            {
                name: 'companyName',
                displayName: 'Raison Sociale',
                cellTemplate: defaultCellTemplate,
                cellClass: 'pointer text-center',
            },
            {
                name: 'fiscalId',
                displayName: 'Identifiant Fiscal',
                cellTemplate: defaultCellTemplate,
                cellClass: 'pointer text-center',
            },
            {
                name: 'legalId',
                displayName: 'Identifiant Légal',
                cellTemplate: defaultCellTemplate,
                cellClass: 'pointer text-center',
            },
            {
                name: 'companyCountry',
                displayName: 'Pays',
                cellTemplate: countryCellTemplate,
                cellClass: 'pointer text-center',
            },
            {
                name: 'pdpEm.startDate',
                displayName: 'kiss_seller.edit.pdp_em.start_date',
                headerCellFilter: 'translate',
                cellClass: 'pointer text-center',
                cellTemplate: dateCellTemplate,
                visible: this.platformColumnsVisibility.EM,
            },
            {
                name: 'pdpEm.endDate',
                displayName: 'kiss_seller.edit.pdp_em.end_date',
                headerCellFilter: 'translate',
                cellClass: 'pointer text-center',
                cellTemplate: dateCellTemplate,
                visible: this.platformColumnsVisibility.EM,
            },
            {
                name: 'pdpRe.startDate',
                displayName: 'kiss_seller.edit.pdp_re.start_date',
                headerCellFilter: 'translate',
                cellClass: 'pointer text-center',
                cellTemplate: dateCellTemplate,
                visible: this.platformColumnsVisibility.RE,
            },
            {
                name: 'pdpRe.endDate',
                displayName: 'kiss_seller.edit.pdp_re.end_date',
                headerCellFilter: 'translate',
                cellClass: 'pointer text-center',
                cellTemplate: dateCellTemplate,
                visible: this.platformColumnsVisibility.RE,
            },
            {
                name: 'companySignOut',
                displayName: '',
                cellTemplate: signOutCellTemplate,
                cellClass: 'pointer text-center',
                width: 80,
                enableSorting: false,
                visible: this.isAdminOrConfigurator(),
            },
        ],
        exporterOlderExcelCompatibility: true,
        enableSorting: true,
        enableGridMenu: false,
        enableColumnMenus: false,
        onRegisterApi: gridApi => {
            this.gridApi = gridApi;
        },
    };
    this.searchCompanies();
  }

  // Indique si l'utilisateur a le profil « Administrateur » ou « CP Technique »
  isAdminOrConfigurator() {
      return ['ADMIN', 'CONFIGURATOR'].some(role => this.SessionSvc.getCurrentUser().roles.includes(role));
  }

  // Popup affichée dans le cas où on détache une société.
  openConfirmCompanySignOut(company) {
    this.$uibModal
      .open({
          component: 'confirmationModal',
          size: 'md',
          resolve: {
              modalTitle: () => {
                return { value: 'commons.confirm' };
              },
              modalMessage: () => {
                return [{ key: this.$translate.instant('principal.companies_details.signOut.confirm_sign_out') }];
              },
              modalCancelButtonText: () => {
                return { value: 'commons.cancel' };
              },
              modalConfirmButtonText: () => {
                return { value: 'commons.ok' };
              },
              data: () => {
                return company;
              },
          },
          backdrop: 'static',
          keyboard: false,
      })
      .result.then(
              company => this.companySignOutConfirmed(company)
        );
  }

  // Détache la société du DO
  companySignOutConfirmed(company) {
    this.PrincipalSvc.companySignOut(this.principal.detail.id,company.companyId).then(
        () => {
            this.logger.success('success.do_update');
            this.$state.reload();
        },
        error => {
            this.logger.error('error.generic', error);
        }
    );
  }

  openImport() {
    this.$uibModal
      .open({
        component: 'modalImportCompany',
        size: 'lg',
        resolve: {
          principal: () => {
            return this.principal;
          }
        },
        backdrop: 'static',
        keyboard: false
      })
      .result.then(() => { window.location.reload() }, () => {});
  }

  createCompany() {
    this.$state.go('app.principal.consult.create_company', { id: this.principal.detail.id });
  }

  getNameIdentifier(val) {
    return this.CompanyService.autocompleteNameId({ principalId: this.principal.detail.id, data: val }).$promise.then(
      result => {
        return result;
      }
    );
  }

  searchCompanies() {
    this.criteria.companyCountry = this.criteria.selectedCountry ? this.criteria.selectedCountry.code : null;
    this.$sessionStorage.companySearchCriteria = this.criteria;
    this.gridOptions.data = this.CompanyService.searchByCriterias(this.criteria);
    this.companyPromise = this.gridOptions.data.$promise;
  }

  clearSearchCompanies() {
    this.criteria.companyName = undefined;
    this.criteria.companyId = undefined;
    this.criteria.companyCountry = undefined;
    this.criteria.selectedCountry = null;
    this.searchCompanies();
  }

  exportCsv() {
    this.gridOptions.exporterCsvFilename = 'principal-societes_' + moment().format('DDMMYYYY') + '.csv';
    this.gridOptions.exporterHeaderFilter = this.$translate.instant;
    this.gridOptions.exporterFieldCallback = (grid, row, col, value) => {
      if (col.name === 'companyCountry') {
        value = this.$translate.instant('country.' + angular.lowercase(value));
      }
      return value;
    };
    this.gridApi.exporter.csvExport(this.uiGridExporterConstants.ALL, this.uiGridExporterConstants.ALL);
  }

  /**
   * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
   */
  getGridHeight(gridApi) {
    return gridHeight(gridApi);
  }

  isEditAuthorized() {
    return this.AuthSvc.isEditAuthorized();
  }

  backList() {
    this.$state.go('do', { tabName: 'principal' });
  }
    activatePdpRe() {
        if (this.principal.detail.authorizedPdpRe) {
           this.updatePdpForLegalEntities(this.platformSens.RE)
        }
    }
    activatePdpEm() {
        if (this.principal.detail.authorizedPdpEm) {
           this.updatePdpForLegalEntities(this.platformSens.EM)
        }
    }
    /** permet de mettre a jour les pdp des societés
     *
     * @param sens sens du partenariat
     */
    updatePdpForLegalEntities(sens){
        const isForRe = sens === this.platformSens.RE;
        this.$uibModal
            .open({
                component: 'modalCreateUpdatePdpRe',
                size: 'md',
                resolve: {
                    nbSoc: () => {
                        return this.getSocIdsSelected().length;
                    },
                    isForRe: () => {
                        return isForRe;
                    }
                },
            }).result.then(
            (dates) => {
                let LegalEntitiesPlatformPartnerHistoryDto ={
                    entitiesIds:this.getSocIdsSelected(),
                    pdp:{
                        startDate:dates.pdpStartDate,
                        endDate:dates.pdpEndDate
                    }
                }
                this.PrincipalSvc.createOrUpdatePdp(LegalEntitiesPlatformPartnerHistoryDto,sens).then(
                    (data)=>{
                        if(data.length != this.getSocIdsSelected().length)
                            this.logger.success('Les sociétés ont été mises à jour');
                        if(data.length !=0 )
                        {
                            this.$uibModal
                                .open({
                                    component: 'modalUnUpdatePdp',
                                    size: 'md',
                                    resolve: {
                                        soc: () => {
                                            return data;
                                        },
                                        isForRe: () => {
                                            return isForRe;
                                        }
                                    },
                                })
                        }

                    }
                )

            }
        );
    }
    isLegalEntitySelected() {
        if (!(this.gridApi === undefined || this.gridApi.selection === undefined)) {
            return this.gridApi.selection.getSelectedRows().length > 0;
        }
        return false;
    }

  getSocIdsSelected() {
     var ids = [];
        if  (!(this.gridApi === undefined || this.gridApi.selection === undefined)){
            var selectedRows = this.gridApi.selection.getSelectedRows();
            for (var i = 0; i < selectedRows.length; i++) {
                ids.push(selectedRows[i].companyId);
            }
        }
        return ids;
    }

}

angular.module('app.principal').component('companiesList', {
  templateUrl: require('./companies-list.html'),
  controller: companiesListCtrl,
  bindings: {
    countries: '<',
    principal: '<',
    keepSearchData: '<'
  }
});
